module.exports = __webpack_public_path__ + "img/em6.0429969e.jpg";